import { render, staticRenderFns } from "./MyEditor.vue?vue&type=template&id=8a9098c6&scoped=true"
import script from "./MyEditor.vue?vue&type=script&lang=js"
export * from "./MyEditor.vue?vue&type=script&lang=js"
import style0 from "./MyEditor.vue?vue&type=style&index=0&id=8a9098c6&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "8a9098c6",
  null
  
)

export default component.exports